<!-- <nav-bar></nav-bar> -->
<!-- <p-growl [life]="3000" [sticky]="false" [(value)]="messages"></p-growl> -->
<p-toast [life]="3000" [sticky]="false"></p-toast>

<app-assistance-survey-graphs
    [title]="graphsInfo.cabin.title"
    [groupType]="groupClass.ASSISTANCE_CASE_SURVEY"
    [setResponseData]="graphsInfo.cabin.respData"
    (applyFilters)="getGraphsData($event, 'cabin')"
    (downloadReport)="onDownload($event)">
</app-assistance-survey-graphs>

<app-assistance-survey-graphs
    [title]="graphsInfo.dispatcher.title"
    [groupType]="groupClass.ASSISTANCE_CASE_DISPATCHER_SURVEY"
    [setResponseData]="graphsInfo.dispatcher.respData"
    (applyFilters)="getGraphsData($event, 'dispatcher')"
    (downloadReport)="onDownload($event)">
</app-assistance-survey-graphs>